import React from "react";
import { connect } from 'react-redux'
import _  from 'lodash'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import Shuffle from "@material-ui/icons/Shuffle";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Done from '@material-ui/icons/Done';
import Close from '@material-ui/icons/Close';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

// @material-ui/core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
// import InputLabel from "@material-ui/core/InputLabel";
import Table from "components/Table/Table.jsx";
import Checkbox from "components/Checkbox/Checkbox";
//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import tableStyles from "assets/jss/material-dashboard-pro-react/components/table";

import "assets/scss/custom/react-select.css";
import Select from 'react-select/lib/Async';

// Actions
import {
  ibTreeFilter,
  ibTreesFetch,
  ibTreeSave,
  ibTreeEditSave,
  ibTreeRemove,
  setIbTreeProfile,
  setIbTreeIb
} from 'actions/ibTrees'

import {
  ibsFetch
} from 'actions/ibs'

import { 
  success,
  danger,
 } from 'actions/notification'

 import SelectIb from 'views/Ibs/Select'
 //import SelectProfile from 'views/Profiles/Select'


import {
  clientsFetchAll
} from 'actions/clients'

import {
  profilesFetchIbs,
  profilesFetchAllFilter,
  profileRemoveTreeNode,
} from 'actions/profiles'

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    textAlign: 'left',
  }),
   /*control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 250,
    borderBottom: '1px solid silver',
  }),*/
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

class List extends React.Component {
  selected = []
  state = {
    action:false,
    actionAddEdit:'',
    listAll:[],
    list:[],
    selected: [],
    value: 0,
    profileId: 0,
    ibList: [],
    form:{
      ibId:false,
      parentIbId:false,
      percentage:0,
    }
  }

  constructor(props){
        super(props)
        this.state.value=props.value
    }

  componentDidMount(){

    //const {ibTrees: {selectedProfileId, selectedProfileName, selectedIbId, selectedIbName}} = this.props

    this.props.profilesFetchAll().then(e=>{
      
      let value=this.props.selectAll?{profileId:0}:e.content[0].profileId;
      let label=this.props.selectAll?{profileName:''}:e.content[0].name;

      this.setState({
        ...this.state,
        value:value,
        profileId: value
      });

      this.setState({...this.state, profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
      this.props.setIbTreeProfile({profileId: value, profileName: label})

      this.props.filter({filter: {profileId: e.content[0].profileId}});
      this.props.fetch().then(e=>this.filter())
    });

    
        this.props.ibsFetch().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

    }); 
  }

  //return select filter 
  filterSelect() {

    return ''; 
  }

  handleChange(event, name){
    this.setState(...this.state,{ [name]: event.profileId })
  }
  //on choose record
  select(id) {
    let select = []
    if (id==='ALL')
      select = (this.state.selected.length > 0)
        ? []
        : this.state.list
        .map(e=>[e.parentIb.ibId,e.ib.ibId])
    else if (this.state.selected.find(el=>el[0]===id[0] && el[1]===id[1])){
      select = this.state.selected.filter(el=>!(el[0]===id[0] && el[1]===id[1]))
    }
    else
      select = this
        .state
        .selected
        .concat([id])
    this.setState({
      ...this.state,
      selected: select
    })
  }
  //Send DELETE request
  confirmDelete() {
    if (this.selected.length === 0) {
      this.props.fetch()
        .then(e=>this.filter());
      this.setState({
        ...this.state,
        alert: <SuccessAlert
          title={`Done!`}
          onConfirm={() => { this.setState({ ...this.state, alert: false }); }}
        />
      });
      return false;
    }
    
    // the below code was commented out for IPP2-52 to remove the root IBTree
    
    if (this.state.list.length<=1) {
      
      if (_.find(this.state.list, {parentIb:{ibId: 1}})) {

        var parentIndex = _.findIndex(this.state.listAll, {ib:{ibId: 1}});

        this.props.remove(this.props.ibTrees.pageable.filter.profileId,this.selected[0][1])
          .then((e) => {
            this.selected = this.selected.slice(1);
            this.setState({
              ...this.state,
              alert: <ProgressAlert
                value={100 - ((this.selected.length * 100) / this.state.selected.length)}
                title={`Delete Companies (${this.state.selected.length - this.selected.length + '/' + this.state.selected.length})`}
              />
            });
            this.confirmDelete();

             this.props.profileRemoveTreeNode(this.props.ibTrees.pageable.filter.profileId,this.state.listAll[parentIndex].ib.ibId)
              .then((e) => {
                  //console.log('root DELETED',this.props.ibTrees.pageable.filter.profileId,this.state.listAll[parentIndex].ib.ibId)
              }  
              ).catch((e) => {
                  //console.log('NOT root DELETED',this.props.ibTrees.pageable.filter.profileId,this.state.listAll[parentIndex].ib.ibId)
                  this.props.danger(e+'',4)
                  this.setState({...this.state,alert:false})
              });
        }).catch((e) => {
          this.props.danger(e+'',4);
          this.setState({...this.state,alert:false})
        });

      }
    } 
    else {

        this.props.remove(this.props.ibTrees.pageable.filter.profileId,this.selected[0][1])
          .then((e) => {
            this.selected = this.selected.slice(1);
            this.setState({
              ...this.state,
              alert: <ProgressAlert
                value={100 - ((this.selected.length * 100) / this.state.selected.length)}
                title={`Delete Companies (${this.state.selected.length - this.selected.length + '/' + this.state.selected.length})`}
              />
            });
            this.confirmDelete();
        }).catch((e) => {
          this.props.danger(e+'',4)
          this.setState({...this.state,alert:false})
        });
    }



  }
  //on choose click delete 
  delete() {

    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} ibTrees \n( ${
          this.state.selected.map(selected => this.state.list.find(e=>selected[0]===e.parentIb.ibId &&selected[1]===e.ib.ibId).ib.name).join(', ')
          } )`}
        onCancel={() => this.setState({ ...this.state, alert: false })}
        onConfirm={() => {
          this.selected = this.state.selected.slice(0);
          this.confirmDelete();
        }}
      />
    });

  }
  // //Change list of displayed ibTrees
  // filterProfiles() {
  //   this.props.profilesFetchAll().then(e=>{
  //     let value = this.props.selectAll ? {profileId:0} : e.content[0].profileId;
  //
  //     this.setState({
  //       ...this.state,
  //       value:value,
  //       profileId: value,
  //       selected: [],
  //       edit: false,
  //       list: !this.parentIbId ? this.props.ibTrees.list.filter(e => e.parentIb) : this.props.ibTrees.list.filter(e => e.parentIb && e.parentIb.ibId === this.parentIbId)
  //     });
  //
  //
  //   });
  // }
  filter(){
    // if (typeof this.props.profiles.list !== 'undefined') {
    //   this.filterProfiles();
    // } else{
    //   this.fetchProfiles()
      this.setState({
        ...this.state,
        selected: [],
        edit: false,
        list: !this.parentIbId ? this.props.ibTrees.list.filter(e => e.parentIb) : this.props.ibTrees.list.filter(e => e.parentIb && e.parentIb.ibId === this.parentIbId),
        listAll: this.props.ibTrees.list
      })
    // }
  }

  // fetchProfiles() {
  //   this.props.profilesFetchAll().then(e=>{
  //     let value = this.props.selectAll ? {profileId:0} : e.content[0].profileId;
  //     this.setState({
  //       ...this.state,
  //       value:value,
  //       profileId: value
  //     });
  //     this.props.filter({filter: {profileId: e.content[0].profileId}});
  //     this.props.fetch().then(e=>this.filter())
  //   });
  // }

  findChild(treeItem, newList){
    this.props.ibTrees.list.forEach((child) =>{
      if(child.parentIb && child.parentIb.ibId === treeItem.ib.ibId){
        newList.push(child)
        this.findChild(child, newList)
      }
    })
  }

  createTreeList(ibParentId){
    if(!ibParentId) {
      return this.props.ibTrees.list.filter(e => e.parentIb)
    } else {
      let newList = this.props.ibTrees.list.filter(e=>e.parentIb && e.parentIb.ibId===this.parentIbId)
      newList.forEach(item => {
        //if item is parent of other tree nodes
        this.props.ibTrees.list.forEach(treeItem => {
          if(treeItem.parentIb && treeItem.parentIb.ibId === item.ib.ibId){
            newList.push(treeItem)
            this.findChild(treeItem, newList)
          }
        })
      })
      return newList
    }
  }
  findTree(){
    //let newList = !this.parentIbId?this.props.ibTrees.list.filter(e => e.parentIb):this.props.ibTrees.list.filter(e=>e.parentIb && e.parentIb.ibId===this.parentIbId)
    this.setState({
      ...this.state,
      selected:[],
      edit:false,
      list: this.createTreeList(this.parentIbId)
    })
  }

  addIb(parentIbId,ibId){
    return  this.props.save({
      ibId:ibId,
      parentIbId:parentIbId,
      percentage:parentIbId ? this.state.form.percentage: 100,
      time:0,
      profileId:this.props.ibTrees.pageable.filter.profileId,
    })
  }
  // send ajax to edit or add Ib Tree
  edit(id=null){
    if(this.state.form.new){
      // if the tree is empty we will add root ib
      if(this.props.ibTrees.list.length===0)
        this.addIb(null,this.state.form.parentIb)
          .then(e=>this.addIb(this.state.form.parentIb,this.state.form.ibId)
            .then(e=>{this.props.success('Success',3); this.props.fetch().then(e=>this.filter())})
            .catch(e=>this.props.danger(e+'',3))
            )
        .catch(e=>this.props.danger(e+'',3))
      else
        this.addIb(this.state.form.parentIb,this.state.form.ibId)
          .then(e=>{this.props.success('Success',3); this.props.fetch().then(e=>this.filter())})
          .catch(e=>this.props.danger(e+'',3))
        }
    
    else
      this.props.edit({
        ibTreeNodeId:id,
        ibId:this.state.form.ibId,
        parentIbId:this.state.form.parentIb,
        percentage:this.state.form.percentage,
        time:0,
        profileId:this.props.ibTrees.pageable.filter.profileId,
      })
      .then(e=>{this.props.success('Success',3); this.props.fetch().then(e=>this.filter())})
      .catch(e=>this.props.danger(e+'',3))
  }

  isRootCompanyExists() {

    const {list}=this.state;

    for(let i=0;i<list.length;i++) {
     
      if ((list[i].parentIb != null) && (list[i].parentIb.company != null)) {
      
        return true;
      
      } 
    
    }

  }

  getRootCompanies() {

    const {ibList}=this.state;
    
    let companyArray = []; 

    if (ibList.length) {

      for(let i=0;i<ibList.length;i++) {
       
        if (ibList[i].company != null) {
        
          companyArray.push(ibList[i].ibId);
          
        } 
      
      }

    }

    return companyArray;

  }

  //Get form of edit 
  getForm(id=null){
    const {classes}= this.props
    const {actionAddEdit}=this.state

    return [
      <div className={classes.tableActions} style={{width: '90px',textAlign: 'right',display: 'block'}}>
        <IconButton 
          onClick={()=>this.setState({
            ...this.state,
            edit:false
          } )} >
          <Close />
        </IconButton>    
        <IconButton 
          onClick={()=>this.edit(id)}>
          <Done />
        </IconButton>
      </div>,
        <SelectIb 
          onSelect={(e)=>{
            this.setState({
            ...this.state,
            form:{
              ...this.state.form,
              parentIb:e.ibId
            }
          })
          }
          }
          excludeData={(this.isRootCompanyExists() && actionAddEdit==='add')?this.getRootCompanies():[]}  
          value={this.state.form.parentIb}
          selectAll={false}
          className={classes.selectIntoTable}
        />,'',
        <SelectIb 
          onSelect={(e)=>{
            this.setState({
            ...this.state,
            form:{
              ...this.state.form,
              ibId:e.ibId
            }
          })
          }
        } 
        excludeData={this.getRootCompanies()}
        value={this.state.form.ibId}
        selectAll={false}
        className={classes.selectIntoTable}
      />,'',
      <CustomInput id="Percentage"
      formControlProps={{
            className:classes.inputIntoTable,
            fullWidth: true
          }}
          inputProps={{
            value:this.state.form.percentage,
            required:true,
            onChange: event =>  this.setState({
              ...this.state,
              form:{
                ...this.state.form,
                percentage:event.target.value
              }
            }),
          }}
          />,''
    ]
  }

  /*
  * onChange select options
  */
  selectProfileChange = ({value, label}) =>{

    if (value!==0) {
      this.setState({...this.state, profileId: value,profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
      this.props.setIbTreeProfile({profileId: value, profileName: label})
      this.props.filter({filter: {profileId: value}});
      this.props.fetch().then(e=>this.filter())
    }

  }

  /*
  * filter by name text
  */
  selectProfileHandleInputChange = (newValue) => {

    this.setState({...this.state, profileName: newValue})
    //this.setState({...this.state,profileId: newValue.profileId});
    return newValue;

  }
  
  /*
  * load select options
  */
  selectProfileLoadOptions = (inputValue, callback) => {

    return this.props.profilesFetchAll(inputValue,false)
        .then((r) => {
          const allOption = {value: 0, label: 'All Profiles'}
          const options = r.content.map((i) => { return {value: i.profileId, label: `${i.name} (${i.profileId})`} })
          return [allOption].concat(options)
        }  
    );
  }

  /*
  * onChange select options
  */
  selectIbChange = ({value, label}) =>{
    
    if (value!==0) {
    
      let { selectedProfileId} = this.props.ibTrees;

      this.setState({...this.state, ibNameSelected: {value, label}})
      
      this.props.filter({filter: {profileId: selectedProfileId,ibId: value}});
      this.props.fetch(selectedProfileId, value).then(e=>this.filter())
    
    }

  }

  /*
  * filter by name text
  */
  selectIbHandleInputChange = (newValue) => {
    this.setState({...this.state, clientName: newValue})
    return newValue;
  }

  /*
  * load select options
  */
  selectIbLoadOptions = (inputValue, callback) => {
    let { selectedProfileId} = this.props.ibTrees;
    
    if (selectedProfileId) {
      
      return this.props.profilesFetchIbs(selectedProfileId,false)
          .then((r) => {
            const allOption = {value: 0, label: 'All Ibs'}
            const options = r.map((i) => {return {value: i.ib.ibId, label: `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}})
            return [allOption].concat(options)
          }  
      );

    } else {

      return {};
    
    }

  }

  



  render() {
    const { ibTrees, permissions } = this.props;
    const {form,edit,selected,list,profileId}=this.state
    
    return (
      <Card>
        {this.state.alert}
        {   
            //Top actions (pgination/limit/add/remove/edit)
            <Actions
              dark={selected.length > 0}
              icon={<Shuffle />}
              title={this.filterSelect()}
              actions={{
                add:<IconButton  onClick={()=>this.setState({
                      ...this.state,
                        edit:[this.parentIbId,0],
                        actionAddEdit:'add',
                        form:{
                          ...form,
                          new:true,
                          ibId:0,
                          parentIb:this.parentIbId
                        }
                      } )}>
                      <AddIcon />
                  </IconButton>,
                delete: (selected.length > 0) && permissions.includes('IB_TREES_DELETE')
                  ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon /></IconButton>
                  : '',
                edit: (selected.length === 1)
                  ? <IconButton onClick={()=>this.setState({
                      ...this.state,
                        edit:selected[0],
                        actionAddEdit:'edit',
                        form:{
                         ...form,
                          new:false,
                          parentIb:selected[0][0],
                          ibId:selected[0][1],
                          percentage:list.find(e=>e.parentIb.ibId===selected[0][0]&&e.ib.ibId===this.state.selected[0][1]).percentage,
                        }
                      })}>
                      <EditIcon />
                    </IconButton>
                  : ''
              } 
            } /> }

        <CardBody>
          {/* If is fetching not display table*/}
          {//Main table
              ibTrees.isFetching?<LinearProgress/>:
              <div>
             
              <div style={{width: '100%',margin: '0 auto',display: 'block'}}>
                <div>
                  <div style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectProfileLoadOptions}
                      defaultOptions
                      onInputChange={this.selectProfileHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectProfileChange(e)}
                      value={this.state.profileNameSelected || ''}
                      placeholder="Search Profiles..."
                    />
                  </div>
                  <div className="" style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectIbLoadOptions}
                      defaultOptions
                      onInputChange={this.selectIbHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectIbChange(e)}
                      value={this.state.ibNameSelected || ''}
                      placeholder="Search Ibs..."
                    />
                  </div>
                </div>

              <Table
                tableHeaderColor="primary"
                sort={ibTrees.pageable.sort}
                tableHead={{
                  checkbox: {name:<Checkbox props={{
                    onClick: () => {this.select('ALL')},
                    checked: this.state.selected.length === this.state.list.length
                  }
                  } />,width: '40px'},
                  parentIb: "Parent Ib",
                  parentIbButton: "",
                  ib: "Child Ib",
                  childIbButton: "",
                  percentage: "Percentage (%)",
                  percentageButton: {name:''},
                }}
                tableData={this.state.list.map((e, i) => 
                  edit && edit[0]===e.parentIb.ibId && edit[1]===e.ib.ibId && !form.new?this.getForm(e.ibTreeNodeId):
                  [
                  <Checkbox props={{ 
                    onClick: () => this.select([e.parentIb.ibId,e.ib.ibId]), 
                    checked: typeof this.state.selected.find(el=>el[0]===e.parentIb.ibId && el[1]===e.ib.ibId )==='object'
                  }} />,
                  (e.parentIb?e.parentIb.name+' '+e.parentIb.lastName:''),
                  ((!this.getRootCompanies().includes(e.parentIb.ibId))?<Button color="info" href={`ib-tree/wizard/${((profileId!==0)?profileId:this.state.list[0].parentIb.ibId)}/${e.parentIb.ibId}`}>Client Rules</Button>:''),
                  e.ib.firstName+' '+e.ib.lastName,
                  (<Button color="info" href={`ib-tree/wizard/${((profileId!==0)?profileId:this.state.list[0].parentIb.ibId)}/${e.ib.ibId}`}>Client Rules</Button>),
                  e.percentage,
                  /*(<Button color="warning" href={`${(this.getRootCompanies().includes(e.parentIb.ibId)?'profiles/'+e.ib.ibId:'profiles/'+((profileId!==0)?profileId:this.state.list[0].parentIb.ibId)+'/ib/'+e.ib.ibId+'/subprofile/'+e.subProfileId)}`}>{(this.getRootCompanies().includes(e.parentIb.ibId)?'Profile':'Sub Profile')}</Button>),*/
                  /*(<div><Button color="warning" href={`${(this.getRootCompanies().includes(e.parentIb.ibId)?'profiles/'+e.ib.ibId:'profiles/'+((profileId!==0)?profileId:this.state.list[0].parentIb.ibId)+'/ib/'+e.parentIb.ibId+'/subprofile/'+e.subProfileId)}`}>{(this.getRootCompanies().includes(e.parentIb.ibId)?'Profile':'Sub Profile')}</Button>*/
                  <Button color="warning" href={`${(this.getRootCompanies().includes(e.parentIb.ibId)?'profiles/'+((profileId!==0)?profileId:this.state.list[0].parentIb.ibId):'profiles/'+((profileId!==0)?profileId:this.state.list[0].parentIb.ibId)+'/ib/'+e.ib.ibId+'/subprofile/'+e.subProfileId)}`}>{(this.getRootCompanies().includes(e.parentIb.ibId)?'Profile':'Sub Profile')}</Button>,
                ]).concat(form.new&&edit?[this.getForm()]:[])} /></div></div>
            }
        </CardBody>
      </Card>
    );
  }
}
const mapStateToProps = (state,props) => {
  return {
    ibList: state.ibs.list,
    ibTrees: state.ibTrees,
    accounts: state.accounts,
    clients: state.clients.list,
    profiles: state.profiles,
    permissions: state.auth.permissions
  
}}
const mapDispatchToProps = (dispatch) => ({
  //Change filter of ibTree.pageable
  filter: (filter) => dispatch(ibTreeFilter(filter)),
  //Save ibTree
  save: (data) => dispatch(ibTreeSave(data)),
  edit: (data) => dispatch(ibTreeEditSave(data)),
  fetch: (profileId, ibId) => dispatch(ibTreesFetch(profileId, ibId)),
  danger: (text,time) => dispatch(danger(text,time)),
  success: (text,time) => dispatch(success(text,time)),
  remove: (profileId,ibId) => dispatch(ibTreeRemove(profileId,ibId)),
  clientsFetchAll: (ibId, profileId, clientName) => dispatch(clientsFetchAll(ibId, profileId, clientName)),
  profilesFetchAll: (profileName, loading) => dispatch(profilesFetchAllFilter(profileName, loading)),
  profilesFetchIbs: (profileId, loading) => dispatch(profilesFetchIbs(profileId, loading)),
  profileRemoveTreeNode: (profileId, ibId) => dispatch(profileRemoveTreeNode(profileId, ibId)),
  setIbTreeProfile: (data) => dispatch(setIbTreeProfile(data)),
  setIbTreeIb: (data) => dispatch(setIbTreeIb(data)),
  ibsFetch: () => dispatch(ibsFetch()),
  
})
export default withStyles(tableStyles)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/IbTree/List.jsx